export const PromotionProductSummaryMolecule = () => {
  return (
    <div
      data-cy="promo-product-summary"
      className="flex w-full mt-2 items-center"
    >
      <div className="w-44 p-3">
        <img src="/images/sweater-promo.png" />
      </div>
      <div className="flex w-full justify-between pl-4 md:pl-2">
        <p className="text-base font-waldo-sans text-left mb-2 font-semibold md:text-lg">
          Sweatshirt
        </p>
        <p className="text-base font-waldo-sans text-right mb-2 font-semibold md:text-lg">
          Free
        </p>
      </div>
    </div>
  );
};
